import { render } from "./WhiteBoard.vue?vue&type=template&id=1c08bb35&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"

import "./WhiteBoard.vue?vue&type=style&index=0&id=1c08bb35&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c08bb35"]])

export default __exports__